import React from 'react';
import DatePicker, { DatePickerProps, registerLocale } from 'react-datepicker';
import { nb } from 'date-fns/locale/nb';
import classnames from 'classnames';
import { Middleware } from '@floating-ui/dom';

registerLocale('nb', nb);

export interface ICheckoutDeliveryDateComponentProps {
    leadText?: string;
    onDateChanged(date: Date): Promise<void>;
    selectedDate: Date
    filterDates(date: Date): boolean;
    enabled: boolean;
    working: boolean;
    hasDeliveryDates: boolean;
}

const DlvryCheckoutDeliveryDateComponent: React.FC<ICheckoutDeliveryDateComponentProps> = ({
    leadText,
    onDateChanged,
    selectedDate,
    filterDates,
    enabled,
    working
}) => {
    filterDates = (filterDates) || ((date: Date): boolean => false);
    onDateChanged = (onDateChanged) || ((date: Date): Promise<void> => Promise.resolve());

    const wrapperRef = React.useRef<HTMLDivElement>(null);

    const baseClassName = 'ms-checkout-delivery-options__deliverydate';
    const customInput = <input type='text' data-clarity-unmask="true" />;
    const sharedProps: DatePickerProps = {
        customInput: customInput,
        locale: 'nb',
        dateFormat: 'dd.MM.yyyy',
        selected: selectedDate,
        disabled: working || !enabled,
        showIcon: true,
        toggleCalendarOnIconClick: true,
        preventOpenOnFocus: true,
        showPopperArrow: false,
        popperModifiers: [
            {
                name: 'offset',
                fn: (state) => {
                    return {
                        x: wrapperRef.current?.offsetLeft || state.x,
                        y: state.y
                    };
                }
            }
        ] as Middleware[],
        icon: working ? (
            <div className={`${baseClassName}__spinner`} />
        ) : (
            <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' className='svg-icon medium'>
                <path
                    d='M6.75 3V5.25M17.25 3V5.25M3 18.75V7.5C3 6.25736 4.00736 5.25 5.25 5.25H18.75C19.9926 5.25 21 6.25736 21 7.5V18.75M3 18.75C3 19.9926 4.00736 21 5.25 21H18.75C19.9926 21 21 19.9926 21 18.75M3 18.75V11.25C3 10.0074 4.00736 9 5.25 9H18.75C19.9926 9 21 10.0074 21 11.25V18.75M12 12.75H12.0075V12.7575H12V12.75ZM12 15H12.0075V15.0075H12V15ZM12 17.25H12.0075V17.2575H12V17.25ZM9.75 15H9.7575V15.0075H9.75V15ZM9.75 17.25H9.7575V17.2575H9.75V17.25ZM7.5 15H7.5075V15.0075H7.5V15ZM7.5 17.25H7.5075V17.2575H7.5V17.25ZM14.25 12.75H14.2575V12.7575H14.25V12.75ZM14.25 15H14.2575V15.0075H14.25V15ZM14.25 17.25H14.2575V17.2575H14.25V17.25ZM16.5 12.75H16.5075V12.7575H16.5V12.75ZM16.5 15H16.5075V15.0075H16.5V15Z'
                    stroke='#0F172A' strokeWidth='1.2' strokeLinecap='round' strokeLinejoin='round'></path>
            </svg>
        )
    };

    return (
        <div className={classnames(baseClassName, {
            [`${baseClassName}__disabled`]: !enabled
        })} ref={wrapperRef}>
            {leadText && (
                <span className={`${baseClassName}__label`}>{leadText}</span>
            )}
            {enabled ? (
                <DatePicker
                    {...sharedProps}
                    filterDate={filterDates}
                    onChange={(date: Date | null) => {
                        if (date) {
                            void onDateChanged(date);
                        }
                    }}
                    onFocus={(e) => {
                        const target = e.target as HTMLInputElement;

                        if (target) {
                            target.readOnly = true;
                            // target.blur();
                        }
                    }}
                />
            ) : (
                <DatePicker
                    {...sharedProps}
                />
            )}
            <br style={{ display: 'none' }} />
        </div>
    );
};

export default DlvryCheckoutDeliveryDateComponent;
